// @ts-nocheck
export function particles(component:any) {
    window.addEventListener("load", () => {
        animationWheat(component);
    });
}

const animationWheat = (data:any) => {
  
    let container = document.querySelector(`.${data}`) as any;
    const controlsAnimation = {
      'container' : data,
      'image' : container.getAttribute("data-img"),
      'count' : container.getAttribute("data-count"),
      'speed' : container.getAttribute("data-speed"),
    }
  
    window.tsParticles &&
    window.tsParticles.load(controlsAnimation.container, {
        fpsLimit: 60,
        fullScreen: {
          enable: false,
        },
        interactivity: {
          detect_on: "canvas",
          events: {
            onClick: { enable: false, mode: "push" },
            onHover: {
              enable: true,
              mode: "repulse",
              parallax: { enable: false, force: 60, smooth: 10 },
            },
            resize: true,
            onresize: {
              density_auto: true,
              density_area: 600,
            },
          },
          modes: {
            bubble: {
              distance: 400,
              duration: 2,
              opacity: 0.8,
              size: 40,
              speed: 3,
            },
            grab: { distance: 400, links: { opacity: 1 } },
            push: { quantity: 4 },
            remove: { quantity: 2 },
            repulse: { distance: 200, duration: 0.4 },
          },
        },
        particles: {
          move: {
            attract: { enable: false, rotateX: 200, rotateY: 1200 },
            bounce: false,
            direction: "bottom",
            enable: true,
            out_mode: "out",
            random: false,
            speed: controlsAnimation.speed,
            straight: false,
          },
          rotate: {
            animation: {
              enable: true,
              speed: 2,
              sync: false,
            },
          },
          number: { density: { enable: true, area: 800 }, value: controlsAnimation.count },
  
          shape: {
            type: "image",
            image: {
              height: 200,
              width: 200,
              src: controlsAnimation.image,
            },
          },
          size: {
            anim: { enable: true, minimumValue: 50, speed: 10, sync: false },
            random: { minimumValue: 8, enable: true },
            value: 100,
          },
        },
        detectRetina: true,
    });
}